import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { WaveDivider } from './WaveDivider';
export function ProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="bg-[#1a2e4a] relative" data-id="element-116">
      <div ref={ref} className="py-16 md:py-24 px-4" data-id="element-117">
        <div className="max-w-3xl mx-auto text-center" data-id="element-118">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.8
        }} data-id="element-119">
            <p className="text-xl md:text-2xl lg:text-3xl text-white leading-relaxed" data-id="element-120">
              En solo <span className="text-amber-400 font-bold" data-id="element-121">7 días</span>,
              dejarás de temerle a tu horario de entrada. No porque el trabajo
              sea más fácil, sino porque{' '}
              <span className="text-[#a8d8d8] font-semibold" data-id="element-122">
                tú serás inquebrantable
              </span>
              .
            </p>
            <p className="text-lg md:text-xl text-gray-300 mt-6 leading-relaxed" data-id="element-123">
              Ya no tendrás que esconderte para recuperar el aliento; sabrás
              cómo mantener la calma mientras el mundo gira a tu alrededor.
            </p>
          </motion.div>
        </div>
      </div>

      <WaveDivider fillColor="#f8fafc" data-id="element-124" />
    </section>;
}